import { server_connection } from 'config';

export const GET_INSTRUCTOR_COURSE_INFO         = '[INSTRUCTOR COURSE APP] GET INSTRUCTOR COURSE INFO';
export const UPDATE_INSTRUCTOR_PAGE_LOADED      = '[INSTRUCTOR COURSE APP] UPDATE PAGE LOADED';
export const GET_INSTRUCTOR_COURSE_EVENTS       = '[INSTRUCTOR COURSE APP] GET INSTRUCTOR COURSE EVENTS';
export const GET_INSTRUCTOR_DASHBOARD_GRADEBOOK = '[INSTRUCTOR COURSE APP] GET INSTRUCTOR DASHBOARD GRADEBOOK';
export const GET_INSTRUCTOR_COURSE_NOTIFICATIONS= '[INSTRUCTOR COURSE APP] GET INSTRUCTOR COURSE NOTIFICATIONS';
export const RESET_INSTRUCTOR_COURSE_DASHBOARD  = '[INSTRUCTOR COURSE APP] RESET INSTRUCTOR COURSE DASHBOARD';

export function getInstructorCourseInfo(company_calendar_course_id) {
    return (dispatch) => {
        fetch(server_connection + '/dashboard/course_dashboard/' + company_calendar_course_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_INSTRUCTOR_COURSE_INFO,
                    payload: responseData
                })
            })
    }
}

export function getInstructorCourseEvents(company_calendar_course_id, instructor_id, unscheduled) {
    return (dispatch) => {
        fetch(server_connection + '/scheduled_course/schedule/instructor/' + company_calendar_course_id + '/' + instructor_id + '/' + unscheduled)
            .then((response) => response.json())
            .then((courseData) => {
                dispatch({
                    type: GET_INSTRUCTOR_COURSE_EVENTS,
                    payload: {courseData, unscheduled}
                })
            })
    }
}

export function getInstructorDashboardGradebook(company_calendar_course_id) {
    return (dispatch) => {
        fetch(server_connection + '/scheduled_course/instructor_dashboard/gradebook/' + company_calendar_course_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_INSTRUCTOR_DASHBOARD_GRADEBOOK,
                    payload: responseData
                })
            })
    }
}

export function updatePageLoaded(setting) {
    return {
        type: UPDATE_INSTRUCTOR_PAGE_LOADED,
        payload: setting
    }
}

export function getInstructorCourseData(company_calendar_course_id, instructor_id, unscheduled) {
    return (dispatch) => {
        Promise.all([
            dispatch(getInstructorCourseInfo(company_calendar_course_id)),
            dispatch(getInstructorCourseEvents(company_calendar_course_id, instructor_id, unscheduled)),
            dispatch(getInstructorDashboardGradebook(company_calendar_course_id)),
            dispatch(getInstructorCourseNotifications(company_calendar_course_id)),
        ]).then(
            () => dispatch(updatePageLoaded(true))
        )
    }
}

export function getInstructorCourseNotifications(company_calendar_course_id) {
    return (dispatch) => {
        fetch(server_connection + '/scheduled_course/notifications/' + company_calendar_course_id + '/' + null )
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_INSTRUCTOR_COURSE_NOTIFICATIONS,
                    payload: responseData
                })
            })
    }
}

export function resetInstructorCourseDashboard() {
    return {
        type: RESET_INSTRUCTOR_COURSE_DASHBOARD,
    }
}


// WEBPACK FOOTER //
// src/main/content/dashboard/store/actions/instructorCourse.actions.js